import {map} from 'lodash';
import {Fragment, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {settingsApi} from 'api';
import {DataWrapper, PredefinedNotifierType} from 'components';
import {useApiData} from 'hooks';
import {SessionActivityName} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

import {AccountSection} from './AccountSection';
import {ActivitySection} from './ActivitySection';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SESSION.ACTIVITIES;

export const Activities: React.FC = () => {
    const {t} = useTranslation();

    const {send: loadSettings, data, loading} = useApiData(
        settingsApi.getActivitiesAi, {notificationType: PredefinedNotifierType.FetchError}
    );

    useEffect(() => {
        loadSettings();
    }, [loadSettings]);

    // The backend decides which activities are configurable and what each of them owns, so the tab renders
    // exactly what it is given rather than keeping its own list.
    const configurableActivities = useMemo(() => Object.keys(data?.blocks || {}) as SessionActivityName[], [data]);

    return (
        <Fragment>
            <div className='tw-mb-4'>{t(T_KEYS.DESCRIPTION)}</div>
            <DataWrapper isLoading={loading} hideContentOnLoading={false}>
                {map(configurableActivities, (activity) => (
                    <ActivitySection
                        key={activity}
                        activity={activity}
                        blocks={data.blocks[activity]}
                        settings={data.activities?.[activity]}
                        providers={data.providers}
                        onSaved={loadSettings}
                    />
                ))}
                {!!data && <AccountSection settings={data.account} providers={data.providers} onSaved={loadSettings} />}
            </DataWrapper>
        </Fragment>
    );
};
